import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CfetBaseComponent, CfetPageNamesConstant, CfetService } from '../../cfet-core';

@Component({
    selector: 'app-customer-eligibility-utf',
    templateUrl: './customer-eligibility-utf.component.html',
    styleUrls: ['./customer-eligibility-utf.component.scss'],
    standalone: false
})
export class CustomerEligibilityUtfComponent extends CfetBaseComponent implements OnInit {

  stepOneIcon = true;
  stepOneSelected = true;
  stepOneTickIcon = false;
  stepOneDone = false;
  stepTwoIcon = true;
  stepTwoSelected = false;
  verificationType: 'self' | 'agency' | null = null;
  stepTwoDone = false;
  stepThreeIcon = true;
  stepThreeSelected = false;
  disableStep = true;
  showHeading = true;
  showEligibilitySection = true;
  showInfoSection = false;
  showStepCompleteHeading = false;
  showDesktopEditButton = false;
  showMobileEditButton = false;
  editButtonClicked!: boolean;
  signupCompleted = false;
  showWorkPlaceSection = false;
  selectedRole: any;
  selectedWorkPlace: any;
  showCompletionPage = false;
  selectedAddress: any;
  selectedCity: any;
  selectedStateInWorkplace: any;
  selectedZipInWorkplace: any;
  divHeight1!: number;
  divHeight2!: number;
  openCancelModal = '';
  showCancelModal = false;
  stepOneRoleDone!: boolean;
  progressTrackerStatus: any = 'roleDetails';

  constructor(private title: Title,
    private router: Router,
    private cfetService: CfetService) { super(); }

  ngOnInit() {
    const currentUrl = window.location.pathname;

if (currentUrl === '/signup/eligibility') {
  sessionStorage.setItem('forceWorkplaceSection', 'true');
}
    this.title.setTitle(this.cfetTitles.eligibility.utfHtmlTitle);
    this.loadCommonListValuesData();
    this.cfetService.isLandingPage.next(false);
    const returnToCompletion = sessionStorage.getItem('returnToCompletion');
    if (returnToCompletion === 'true') {
      const orgData = JSON.parse(sessionStorage.getItem('orgDetailInfo') || '{}');
      const fakeEvent = {
        eligibilityStatus: {
          signupDoneStatus: true,
          isSpaTerriroryState: false
        },
        selectedName: orgData.org_name,
        selectedAddress: orgData.address,
        selectedCity: orgData.city,
        selectedStateInWorkplace: orgData.state,
        selectedZipInWorkplace: orgData.zipcode
      };
      const storedVerificationType = sessionStorage.getItem('verificationType');
      if (storedVerificationType === 'agency' || storedVerificationType === 'self') {
        this.verificationType = storedVerificationType as 'agency' | 'self';
      }
      this.onEligibilityCompletion(fakeEvent);
      sessionStorage.removeItem('returnToCompletion');
    }
  }
  onActivate(componentRef: any) {
    if (componentRef.isRoleSelected) {
      componentRef.isRoleSelected.subscribe((event: any) => {
        this.isRoleSelected(event);
      });
    }
    if (componentRef.progressTrackerEvent) {
      componentRef.progressTrackerEvent.subscribe((event: any) => {
        this.handleProgressTrackerEvent(event);
      });
    }

    if (componentRef.eligibilitycompletionstatus) {
      componentRef.eligibilitycompletionstatus.subscribe((event: any) => {
        this.onEligibilityCompletion(event);
      });
    }
    if (componentRef.editSelected) {
      componentRef.editSelected.subscribe((event: any) => {
        this.onEligibilityCompletion(event);
      });
    }
    if (componentRef.showCancelModal) {
      componentRef.showCancelModal.subscribe((event: any) => {
        this.cancelModal(event);
      });
    }
    if (componentRef.verificationTypeChange) {
      componentRef.verificationTypeChange.subscribe((type: any) => {
        this.onVerificationChange(type);
      });
    }
  }
  goToEligibility(event:any) {
    this.editButtonClicked = true;
    this.showInfoSection = false;
    this.showEligibilitySection = true;
    // disable Second Step and go to Step One
    this.disableStep = true;
    this.stepOneIcon = true;
    this.stepOneTickIcon = false;
    this.showHeading = true;
    this.showStepCompleteHeading = false;
    this.showDesktopEditButton = false;
    this.showMobileEditButton = false;
    this.stepOneDone = false;
    this.showWorkPlaceSection = false;
  }
  isRoleSelected(event:any) {
    this.stepOneRoleDone = event;
  }
  onVerificationChange(type: 'self' | 'agency' | null) {
    console.log('Verification changed:', type);
    this.verificationType = type;
  }
  handleProgressTrackerEvent(event:any) {
    this.progressTrackerStatus = event;
    console.log('status' + this.progressTrackerStatus);
  }
  onEligibilityCompletion(event:any) {
    console.log("PARENT RECEIVED eligibilitycompletionstatus:", event);
    // On click of signup button
    if (event && event.eligibilityStatus && event.eligibilityStatus.signupDoneStatus) {
      this.signupCompleted = true;
      this.showInfoSection = true;
      this.showEligibilitySection = false;
      if (event.eligibilityStatus.isSpaTerriroryState) {
        sessionStorage.setItem('isSpaTerriroryState', JSON.stringify(event.eligibilityStatus.isSpaTerriroryState));
      }
      const isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
      if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
        || isIPadPro) {
        this.showHeading = false;
        this.showStepCompleteHeading = true;
        this.stepOneDone = true;
        this.showWorkPlaceSection = false;
        this.showCompletionPage = true;
        this.stepOneTickIcon = true;
        this.stepOneRoleDone = true;
        this.progressTrackerStatus = 'EligibilityCompletion';
        this.showOrHideRegistrationPage(event);
      } else {
        this.showHeading = false;
        this.showStepCompleteHeading = true;
        this.stepOneDone = true;
        // Skip workplace and go directly to completion
        this.showWorkPlaceSection = false;
        this.showCompletionPage = true;
        this.stepOneTickIcon = true;
        this.stepOneRoleDone = true;
        this.progressTrackerStatus = 'EligibilityCompletion';
      }
    }
  }

  showOrHideRegistrationPage(event:any) {
    if (sessionStorage.getItem('c_id') && JSON.parse(sessionStorage.getItem('c_id') || 'null') === 'y') {
      window.location.href = environment.att_auth_domain + CfetPageNamesConstant.UTF_SYNC_DETAILS_PAGE;
    } else if (environment.hideRegistrationPage || event.eligibilityStatus.isSpaTerriroryState) {
      this.router.navigate([CfetPageNamesConstant.CUSTOMER_PERSONAL_INFORMATION_UTF]);
    } else {
      this.router.navigate([CfetPageNamesConstant.UTF_REGISTRATION]);
    }
  }

  cancelModal(event:any) {
    if (event) {
      this.showCancelModal = true;
      this.openCancelModal = 'open';
    }
  }

  closeModal(event:any) {
    if (event === 'modalClose') {
      this.openCancelModal = 'close';
    }
  }

   loadCommonListValuesData() {
    if (!sessionStorage.getItem('ngStorage-commonListValues') ||
    Object.keys(sessionStorage.getItem('ngStorage-commonListValues') || '').length === 0) {
  this.cfetService.getCommonList().subscribe();
}
  }
}

